import type { SVGProps } from "react";
export default function SvgReply(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-reply-icon lucide-reply"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M20 18v-2a4 4 0 0 0-4-4H4" />
			<path d="m9 17-5-5 5-5" />
		</svg>
	);
}
